var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-90%",
    y: "-90%",
    width: "280%",
    height: "280%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.316%",
    y1: "21.974%",
    x2: "0%",
    y2: "69.777%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3039",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A94A7",
    offset: "48.131%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3039",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.892%",
    y1: ".428%",
    x2: "24.856%",
    y2: "100%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B404C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333843",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.833 63.264c-14.9 1.866-25.108-6.384-22.797-18.428 2.31-12.043 16.264-23.319 31.166-25.184C56.103 17.786 66.31 26.036 64 38.08c-2.311 12.043-16.264 23.319-31.167 25.184z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0270D7",
    d: "M35.521 6.938L12.04 35.843l48.939 16.136L84.46 23.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02CBB1",
    d: "M20 65.494L35.822 74 36 26.506 20.176 18z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 31)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.48,
    fill: "#1D2026",
    filter: "url(#a)",
    d: "M1 0h40v40H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.261 54.752l-9.71-18.785C.096 33.152-.389 29.783.327 26.051 2.637 14.01 16.59 2.732 31.492.867 41.776-.42 49.824 3.11 53.065 9.38l9.71 18.785c-3.242-6.27-11.29-9.8-21.573-8.514C26.3 21.518 12.347 32.793 10.036 44.837c-.716 3.732-.23 7.1 1.225 9.915",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00BFFB",
    d: "M22.991 85.677l.826-6.614L7.855 84.8l-.825 6.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.32,
    fill: "#00BFFB",
    d: "M106.721 46.737l4.408-2.801-13.699-6.737L93.022 40z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon01);
export default __webpack_public_path__ + "static/media/feature-icon-01.9c67b4a0a269d7824c57e9cc4c0863a8.svg";
export { ForwardRef as ReactComponent };